import { render, staticRenderFns } from "./capnhatbaiviet.vue?vue&type=template&id=f07b8266&"
import script from "./capnhatbaiviet.vue?vue&type=script&lang=js&"
export * from "./capnhatbaiviet.vue?vue&type=script&lang=js&"
import style0 from "./capnhatbaiviet.vue?vue&type=style&index=0&id=f07b8266&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports